/**
 * CookieConsent.jsx
 * Banner persetujuan cookie — GDPR/UU PDP compliant
 * Simpan pilihan di localStorage, hilang setelah disetujui
 */
import React, { useState, useEffect } from 'react';
import { Cookie, X, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'nm_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Tampilkan setelah 1.5 detik jika belum pernah disetujui
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() }));
    setVisible(false);
    // Di sini kamu bisa aktifkan GA4 analytics setelah consent
    // window.gtag && window.gtag('consent', 'update', { analytics_storage: 'granted' });
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: false, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[100] p-4 sm:p-6 animate-slide-up"
    >
      <div className="max-w-4xl mx-auto bg-primary-950 border border-primary-800 rounded-2xl shadow-2xl p-5 sm:p-6">
        <div className="flex items-start gap-4">
          {/* Icon */}
          <div className="bg-amber-500/20 rounded-xl p-2.5 shrink-0 mt-0.5">
            <Cookie size={22} className="text-amber-400" />
          </div>

          {/* Text */}
          <div className="flex-1 min-w-0">
            <h3 className="font-display text-white font-bold text-base mb-1">
              Kami menggunakan cookies 🍪
            </h3>
            <p className="text-white/60 text-sm font-sans leading-relaxed">
              Website ini menggunakan cookies untuk meningkatkan pengalaman Anda, menganalisis
              trafik, dan menampilkan konten yang relevan. Dengan melanjutkan, Anda menyetujui
              penggunaan cookies sesuai{' '}
              <Link to="/privacy" className="text-amber-400 hover:text-amber-300 underline">
                Kebijakan Privasi
              </Link>{' '}
              kami.
            </p>
          </div>

          {/* Close */}
          <button
            onClick={decline}
            aria-label="Tutup banner cookie"
            className="p-1.5 rounded-lg hover:bg-white/10 text-white/40 hover:text-white transition-colors shrink-0"
          >
            <X size={16} />
          </button>
        </div>

        {/* Actions */}
        <div className="flex flex-wrap gap-3 mt-4 ml-14">
          <button
            onClick={accept}
            className="flex items-center gap-1.5 px-5 py-2 bg-amber-500 hover:bg-amber-400 text-primary-950 text-sm font-sans font-bold rounded-xl transition-colors"
          >
            Terima Semua <ChevronRight size={14} />
          </button>
          <button
            onClick={decline}
            className="px-5 py-2 border border-white/20 hover:border-white/40 text-white/70 hover:text-white text-sm font-sans rounded-xl transition-colors"
          >
            Hanya Esensial
          </button>
          <Link
            to="/privacy"
            className="px-4 py-2 text-white/40 hover:text-white/70 text-sm font-sans transition-colors"
          >
            Pelajari lebih lanjut
          </Link>
        </div>
      </div>
    </div>
  );
}
